export { default } from "./InfoBlock";
export * from "./InfoBlock";
export * from "./InfoBlock.model";
